
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SMUser } from "@/store";
import Banner from "@/components/V2/Banner/Banner.vue";
import {
  IS_NOT_SPONSOR,
  SL_IS_STARTED,
  SL_IS_STARTED_AND_ON_FINAL_STEPS,
  NEED_TO_COMPLETE_ACCOUNT_SETUP,
  COMPLIANCE_SUBSCRIPTION_EXPIRED,
  TRIAL_IS_ENDING_SOON,
  UPGRADE_TO_PREMIUM,
  HOME_OFFICE_AUDITS,
  SL_GRANTED,
  ONGOING_RESPONSIBILITIES,
} from "@/constants/banner";

const ICONS = {
  close: "close-outline",
  information: "information-circle",
};

@Component({
  components: { Banner },
})
export default class BannersSection extends Vue {
  @Prop({ type: [Object, String], default: () => ({}) }) readonly src;
  @Prop({ type: Boolean, default: false }) readonly short: boolean;
  @Prop({ type: String, default: null }) readonly type: string;

  ICONS = ICONS;

  get isSlOnFinalSteps(): boolean {
    return this.src?.banner?.sl_is_not_on_first_step || false;
  }

  emitBannerAction(payload) {
    payload?.action?.();
  }

  get isOnboardingCompleted() {
    return this.src?.banner?.employer_completed_account_setup_onboarding;
  }

  get hasOnboardingTask() {
    return this.src?.banner?.account_setup_onboarding_task_id > 0;
  }

  banners = [];

  calculateBanners() {
    this.banners = [];

    // Compliance Blocked
    if (SMUser.isComplianceBlocked) {
      this.banners.push(COMPLIANCE_SUBSCRIPTION_EXPIRED);
      this.banners.push(HOME_OFFICE_AUDITS);

      return;
    }

    // Banners Action

    if (!this.isOnboardingCompleted && this.hasOnboardingTask) {
      this.banners.push(NEED_TO_COMPLETE_ACCOUNT_SETUP);

      return;
    }

    if (SMUser.isSLStarted && !SMUser.isSponsor) {
      const SL_STARTED_BANNER_KEY = this.isSlOnFinalSteps
        ? SL_IS_STARTED_AND_ON_FINAL_STEPS
        : SL_IS_STARTED;

      this.banners.push(SL_STARTED_BANNER_KEY);

      return;
    }

    if (!SMUser.isSponsor) {
      this.banners.push(IS_NOT_SPONSOR);

      return;
    }

    // Banners

    // Compliance Trial
    if (SMUser.isSubscriptionStatusTrial) {
      this.banners.push(TRIAL_IS_ENDING_SOON);
      this.banners.push(HOME_OFFICE_AUDITS);

      return;
    }

    // Active compliance subscription (exclude premium), Compliance employee tasks count > 0, completed compliance employee tasks = 0
    if (
      (SMUser.isBasicSubscriptionActive || SMUser.isStandardSubscriptionActive) &&
      this.src?.banner?.employees_count > 0 &&
      this.src?.banner?.employee_has_completed_task == false
    ) {
      this.banners.push(ONGOING_RESPONSIBILITIES);
      this.banners.push(HOME_OFFICE_AUDITS);

      return;
    }

    // Sponsor Licence granted, user has active compliance subscription, no candidates or visa cases started.
    if (
      SMUser.isSponsor &&
      SMUser.isSponsorConfirmation &&
      SMUser.isComplianceSubscriptionActive &&
      this.src?.banner?.has_any_visa_cases == false &&
      SMUser.hasSLCase
    ) {
      this.banners.push(SL_GRANTED);

      return;
    }

    if (!SMUser.isPremiumSubscription) {
      this.banners.push(UPGRADE_TO_PREMIUM);
      this.banners.push(HOME_OFFICE_AUDITS);
    }
  }

  @Watch("src", { immediate: true, deep: true })
  isSrcChanged() {
    this.calculateBanners();
  }
}
